<template>
  <v-sheet style="overflow: auto;" class="d-flex justify-space-between flex-column" v-if="info__data" height="100%">
    <Document__WP_InfoCard v-if="info__data.__type === 'document'" />
    <SpecCard__WP_InfoCard v-else />
  </v-sheet>
  <v-sheet style="overflow: auto; opacity: 0.3" class="d-flex justify-center align-center font-weight-bold" v-else>
    ПУСТО
  </v-sheet>
</template>

<script>
import { InfoBlock } from "@/store/wp_planner/info.store";
import { RightDrawer } from "@/store/wp_planner/misc.store";
import SpecCard__WP_InfoCard from "@/components/wp_planner/info_cards/specialist.ic.vue";
import Document__WP_InfoCard from "@/components/wp_planner/info_cards/document.ic.vue";

export default {
  name: "Info__WP_Widget",
  components: { Document__WP_InfoCard, SpecCard__WP_InfoCard },
  data() {
    return {

    }
  },
  computed: {
    right_drawer_tab: {
      get() {
        return RightDrawer().get()
      },
      set(value) {
        RightDrawer().set(value)
      }
    },
    info__data: {
      get() {
        return InfoBlock().get()
      },
      set(value) {
        InfoBlock().set(value)
      }
    }
  }
}
</script>

<style scoped>

</style>
